const getWebsiteBaseUrl = () =>
  (process.env.REACT_APP_WEBSITE_URL || "http://localhost:3000").replace(/\/$/, "");

const formatDateParam = (dateValue) => {
  if (!dateValue) return null;
  if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
    return dateValue.slice(0, 10);
  }
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 10);
};

export const getPackageWebsiteUrl = (packageId, travelDate) => {
  if (!packageId) return null;
  const date = formatDateParam(travelDate);
  const query = date ? `?date=${date}` : "";
  return `${getWebsiteBaseUrl()}/package/${packageId}${query}`;
};
